var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-button",
    _vm._g(
      _vm._b(
        { class: [_vm.getButtonClasses] },
        "base-button",
        _vm.baseButtonProps,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.icon && !_vm.isRightIcon
        ? _c("base-icon", {
            class: _vm.onlyIcon ? "" : "gfu-btn__icon",
            attrs: { name: _vm.icon, "icon-namespace": _vm.iconNamespace },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _vm.icon && _vm.isRightIcon
        ? _c("base-icon", {
            class: _vm.onlyIcon ? "" : "gfu-btn__icon",
            attrs: { name: _vm.icon, "icon-namespace": _vm.iconNamespace },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }